import { type JsonDataItem } from 'types';
import { baseQuery } from '../baseQuery';

export const postServiceSelection = async ({
  products,
  customerId,
  devices,
  description,
  os,
  serviceType,
  previousJob,
  warrantyReason,
  productAdditionalSelection,
  additionalProblem,
}: JsonDataItem) => {
  const { data } = await baseQuery('service-selection', {
    type: 'POST',
    body: {
      product_selection: products,
      customer_id: customerId,
      device_selection: devices,
      description,
      os_selection: os,
      additional_problem: additionalProblem,
      service_attributes: {
        job_service_type: serviceType,
        previous_job_id: previousJob,
        warranty_reason_id: warrantyReason,
      },
      product_additional_selection: productAdditionalSelection,
    },
  });

  return data;
};
